import { Assert } from '@team/assert';

/**
 * Создаёт функцию, исполнение которой вызовет все переданные функции.
 */
export const callMultiple =
  (...fns: Maybe<AnyFunction>[]) =>
  (...args: unknown[]): void => {
    fns.filter(Assert.isFunction).forEach((fn) => {
      fn(...args);
    });
  };
